

import BasicState from "src/libs/basic-view"
import TestsResultsForm from "./tests-results/TestsResultsForm"

export default class TestsResultsView extends BasicState {
    props: any
    addRender = () => {
        return <div className="d-flex w-100 m-0 position-relative">
            <TestsResultsForm {...this.props} />  
        </div>
    }
}